import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import WorkoutPlans from './pages/WorkoutPlans';
import Testimonials from './pages/Testimonials';
import Gallery from './pages/Gallery';
import Community from './pages/Community';
import Contact from './pages/Contact';
import CalorieCalculator from './pages/CalorieCalculator';

function App() {
  // Social Media Links
  const YOUTUBE_CHANNEL = 'https://www.youtube.com/@Fitness_coach_129';
  const INSTAGRAM_PROFILE = 'https://www.instagram.com/sabari_prime_fit?igsh=MTU0aTJvZ2Z1N21yMQ==&utm_source=ig_contact_invite';

  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header YOUTUBE_CHANNEL={YOUTUBE_CHANNEL} INSTAGRAM_PROFILE={INSTAGRAM_PROFILE} />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home YOUTUBE_CHANNEL={YOUTUBE_CHANNEL} INSTAGRAM_PROFILE={INSTAGRAM_PROFILE} />} />
            <Route path="/about" element={<About YOUTUBE_CHANNEL={YOUTUBE_CHANNEL} INSTAGRAM_PROFILE={INSTAGRAM_PROFILE} />} />
            <Route path="/services" element={<Services />} />
            <Route path="/workout-plans" element={<WorkoutPlans YOUTUBE_CHANNEL={YOUTUBE_CHANNEL} />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/gallery" element={<Gallery YOUTUBE_CHANNEL={YOUTUBE_CHANNEL} />} />
            <Route path="/community" element={<Community YOUTUBE_CHANNEL={YOUTUBE_CHANNEL} INSTAGRAM_PROFILE={INSTAGRAM_PROFILE} />} />
            <Route path="/contact" element={<Contact YOUTUBE_CHANNEL={YOUTUBE_CHANNEL} INSTAGRAM_PROFILE={INSTAGRAM_PROFILE} />} />
            <Route path="/calorie-calculator" element={<CalorieCalculator />} />
          </Routes>
        </main>
        <Footer YOUTUBE_CHANNEL={YOUTUBE_CHANNEL} INSTAGRAM_PROFILE={INSTAGRAM_PROFILE} />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
